import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const Rectangle = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="68" viewBox="0 0 68 69" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M67.527 0.719681H0.203186V68.0435H67.527V0.719681Z" fill={`url(#${patternId})`} fillOpacity="0.6" />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
